import { WeblinkDownloadable, WeblinkDownloadsCounts } from 'reactApp/modules/public/public.types';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { AccessRights, Count, Kind, SubKind, Url, VirusScan, Weblink } from 'reactApp/types/Tree';
import { ESearchOptionSource } from 'reactApp/ui/WebSearch/WebSearch.data';

export interface ApiSearchResponseFolder extends WeblinkDownloadsCounts {
    name_parts?: [string, 0 | 1][];
    home: string;
    kind: Kind;
    name: string;
    public: Weblink;
    favorite?: 1 | 0;
}

export interface ApiSearchFolderResponseFile {
    name_parts?: [string, 0 | 1][];
    home: string;
    illegal: 1 | 0;
    blocked: 1 | 0;
    favorite?: 1 | 0;
    hash: string;
    kind: Kind;
    mtime: number;
    name: string;
    size: number;
    virus_scan: VirusScan;
    public: Weblink;
}

export type SearchFile = Omit<ApiSearchResponseFile, 'srch_src'> & { srchSrc?: ESearchOptionSource };

export type ApiSearchResponceList = (ApiSearchResponseFolder | ApiSearchFolderResponseFile)[];

export interface ApiSearchResponseFile extends WeblinkDownloadable {
    home?: string;
    weblink?: string;
    size: number;
    subKind: SubKind;
    kind: Kind;
    parent: '/';
    isFolder: false;
    hash: string;
    virusScan: VirusScan;
    parentFolder: string;
    mtime: number;
    pos?: number;
    srch_src?: string;
    ext: string;
    nameWithoutExt: string;
    name: string;
    id: string;
    storage: EStorageType.search;
    isIllegal: boolean;
    isBlocked: boolean;
    nameParts?: [string, 0 | 1][];
    thumbnails?: {
        [key: string]: string;
    };
    url?: Url;
    __reduxTree: true;
    weblinkAccessRights?: AccessRights;
    weblinkExpires?: number;
    ctime?: number;
    expiresTimeSize?: number;
    weblinkDomestic?: boolean;
    isInFavorites?: boolean;
    isReadOnly?: boolean;
}

export interface IHistoryItem {
    text: string;
}

export interface SearchFolder extends WeblinkDownloadable {
    kind: Kind;
    weblink?: string;
    parentFolder: string;
    id: string;
    name: string;
    storage: EStorageType.search;
    parent: '/';
    isFolder: true;
    home?: string;
    pos?: number;
    nameParts?: [string, 0 | 1][];
    __reduxTree: true;
    weblinkAccessRights?: AccessRights;
    weblinkExpires?: number;
    ctime?: number;
    expiresTimeSize?: number;
    weblinkDomestic?: boolean;
    weblinkAutoDelete?: boolean;
    isInFavorites?: boolean;
    isReadOnly?: boolean;
}

export type SearchItem = SearchFolder | SearchFile;

export interface SearchRequestParams {
    query: string;
    xPageId: string;
    xReqId: string;
    path?: string;
    type?: string;
    source?: string;
}
export interface SearchState {
    '/': {
        count: Count;
        id: '/';
        childs: string[];
        isLoading: boolean;
        isLoaded: boolean;
        hasMoreToLoad: boolean;
        name: string;
        error: boolean;
    };
    list: {
        [key: string]: SearchItem;
    };
    listFull: (ApiSearchResponseFolder | ApiSearchFolderResponseFile)[];
    requestParams: SearchRequestParams;
    offset: number;
    searchStartLocation: { id: string; search: string };
    searchHistory: IHistoryItem[];
    emptyFilters: boolean;
}

export interface SearchApiRequestParams {
    q: string;
    path: string;
    limit: number;
    depth: number;
    ext?: string;
    type?: string;
    srch_src?: ESearchOptionSource;
}

export interface NewSearchApiRequestParams {
    query: string;
    path: string;
    limit: number;
    offset?: number;
    depth: number;
    exts?: string;
    type?: string;
    size?: { from: number; till: number };
    mtime?: { from: number; till: number };
    new_srch?: boolean;
    srch_src?: string;
}

export interface SearchHistoryGetApiRequestParams {
    query: string;
}

export interface SearchLoadMoreData {
    offset: number;
    list: (ApiSearchResponseFolder | ApiSearchFolderResponseFile)[];
}

export interface VirusScanResponce {
    [key: string]: {
        illegal: number;
        blocked: number;
        virus_scan: string;
    };
}

export interface SearchAnalyticsParams {
    place: 'touch' | 'web';
    name_files?: string;
    type_content?: string;
    pos?: number;
    hash?: string;
    size?: number;
    section: string;
    search_phrase: string;
    page_id: string;
    req_id: string;
}

export interface SearchLoadParams {
    queryParam?: string;
    type?: string;
    folder?: string;
    isAlbumsSearch?: boolean;
}

export enum EActionSearch {
    searchClose = 'search-close',
    searchClear = 'search-clear',
    filtersPlacement = 'filters-placement',
    filters = 'filters',
    copyPastText = 'copy-paste-text',
    openInNewTab = 'open-in-new-tab',
    initialClick = 'initial_click',
    closePublic = 'close-public',
}
